import { AxiosError } from 'axios'
import { ElMessage } from 'element-plus'

import i18n from '@shared/i18n'
import { errorCodesMapper } from '@shared/utils/constants/errors/codes'

import { ApiErrorCode } from '@protos/api_error_code_pb'
import {
  ApiErrorResponse,
  ApiErrorResponse_Error,
} from '@protos/response/api_error_response_pb'

import { PlainMessage } from '@bufbuild/protobuf'
import { JsonValue } from '@protobuf-ts/runtime'

export const getErrorMessages = (
  errors: PlainMessage<ApiErrorResponse_Error>[]
) =>
  errors.reduce((messages, error) => {
    if (error.type.case === 'error') {
      const { message } = error.type.value
      messages.push(message)
    } else if (error.type.case === 'genericError') {
      const { message } = error.type.value
      messages.push(message)
    }

    return messages
  }, [] as string[]) ?? []

export const getErrorCodes = (errors: PlainMessage<ApiErrorResponse_Error>[]) =>
  errors?.reduce(
    (codes: ApiErrorCode[], error: PlainMessage<ApiErrorResponse_Error>) => {
      if (error?.type?.case === 'error' && error?.type?.value) {
        const data = error?.type?.value
        data?.code && codes.push(data?.code)
      }

      return codes
    },
    [] as ApiErrorCode[]
  ) ?? []

export const getErrorByCode = (
  errors: PlainMessage<ApiErrorResponse_Error>[],
  errorCode: ApiErrorCode
) =>
  errors.find((error) => {
    if (error.type.case === 'error' && error.type.value.code === errorCode) {
      return error.type.value
    }
  })

export const getErrorByKey = (
  errors: PlainMessage<ApiErrorResponse_Error>[],
  errorKey: string
) =>
  errors.find((error) => {
    if (error.type.case === 'error' && error.type.value.key === errorKey) {
      return error.type.value
    }
  })

export const showErrorBasedOnCodeError = (
  e: unknown,
  customData?: { defaultMessage?: string; codeMapper?: Record<number, string> }
) => {
  const error = e as AxiosError
  const { errors } = ApiErrorResponse.fromJson(
    error.response?.data as JsonValue
  )
  const codes = getErrorCodes(errors)
  const mapper = customData?.codeMapper || errorCodesMapper
  codes.forEach((item) => {
    if (mapper[item]) {
      ElMessage({
        type: 'error',
        grouping: true,
        message: mapper[item],
      })
    } else {
      ElMessage({
        type: 'error',
        grouping: true,
        message:
          customData?.defaultMessage ?? i18n.global.t('common.httpError'),
      })
    }
  })
}
